import React, { useEffect, useRef, useState } from "react";
import Lottie from "lottie-react";
import { createPortal } from "react-dom";
import ReactCountryFlag from "react-country-flag";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";
import arrowIcon from "../../../assets/images/Vector_btn.png";
import arrowIconWhite from "../../../assets/images/arrowIconWhite.png";
import LottieAnimation from "../../../assets/json/sezione-03-popup-01-00-it.json";
import ItaFlag from "../../../assets/images/ita-bandiera.png";
import Sezione3popup2Grecia from "./sezione-3-popup-2-grecia";
import Sezione3popup3 from "./sezione-3-popup-3";

const Flag = ({ code, className = "" }) => (
  <ReactCountryFlag
    countryCode={code}
    svg
    aria-label={code}
    className={className}
    style={{ width: "1.1em", height: "1.1em" }}
  />
);

export default function Sezione3popup1({ isOpen, onClose }) {
  const overlayRef = useRef(null);
  const [openId, setOpenId] = useState(null);

  // ⬇️ NEW: stati dei popup figli
  const [isGreciaOpen, setIsGreciaOpen] = useState(false);
  const [isReportOpen, setIsReportOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Perimetro di Consolidamento", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <>
      <div
        ref={overlayRef}
        className="fixed inset-0 z-[999] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
        onMouseDown={(e) => {
          if (e.target === overlayRef.current) onClose?.();
        }}
        role="dialog"
        aria-modal="true"
        aria-label="Perimetro di consolidamento"
      >
        <div
          className="
            relative w-full md:w-[1280px] bg-white shadow-2xl
            max-h-[90vh] overflow-y-auto overscroll-contain
          "
          style={{ background: "#E8F7FD", WebkitOverflowScrolling: "touch" }}
        >
          {/* Azioni in alto */}
          <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
            <button
              onClick={() => onShare("Sezione3popup1")}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
              title="Condividi"
              aria-label="Condividi"
            >
              <img src={shareIcon} alt="" className="h-4 w-4" />
            </button>
            <button
              onClick={onClose}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
              title="Chiudi"
              aria-label="Chiudi"
            >
              <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
            </button>
          </div>

          {/* Contenuto */}
          <div className="p-8">
            <div className="flex flex-col gap-6">
              <div className="flex flex-col gap-3 w-full md:w-1/2">
                <h2 className="text-[#002655] text-[30px] leading-[30px] md:text-[40px] md:leading-[40px]">
                  Perimetro di consolidamento
                </h2>
                <p className="uppercase text-[#002655] text-[18px] leading-[22px] md:text-[22px] md:leading-[28px]">
                  Situazione al&nbsp;31 dicembre 2025 (% di interessenza)
                </p>
              </div>

              {/* DESKTOP: Lottie + bottone */}
              <div className="relative hidden lg:block lg:w-[1080px] lg:h-[1500px] mx-auto">
                <Lottie
                  className="absolute inset-0 w-full h-full"
                  animationData={LottieAnimation}
                  loop={false}
                  autoplay
                />

                <div className="absolute top-[200px] right-[150px]">
                  <h3 className="text-[#002655] text-[25px] md:text-[30px] font-bold leading-[1.1em] mb-2">CAPOGRUPPO<br/>Società Benefit</h3>
                  <button
                    className="bt-secondary flex items-center gap-2"
                    style={{ fontSize: "16px" }}
                    onClick={() => setIsReportOpen(true)} 
                  >
                  <img src={arrowIcon} alt="Arrow" className="w-[25px] h-[25px]" />
                    Approfondisci
                  </button>
                </div>

                <button
                  className="bt-secondary flex items-center gap-2 absolute left-[95px] top-[1255px]"
                  style={{ fontSize: "16px" }}
                  onClick={() => setIsGreciaOpen(true)}
                >
                  <img src={arrowIcon} alt="Arrow" className="w-[25px] h-[25px]" />
                  Approfondisci
                </button>
              </div>

              {/* CTA finale */}
                  <div className="hidden md:block mt-6 flex justify-start">
                    <a href="https://www.realegroup.eu/groupshare/0/IT/ListaReportsAndAccounts/87/BILANCIO%20CONSOLIDATO%20RG%202025.pdf#page=18" target="_blank">
                      <button
                        className="bt-secondary2 text-sm px-4 py-2"
                      >
                        <img src={arrowIconWhite} alt="Arrow" className="inline-block mr-2 w-[20px] h-[20px]" />
                        Consulta il Report - cap. 1 par. 1.1.3.1
                      </button>
                    </a>
                  </div>

              {/* MOBILE: due colonne con linea centrale + pannello centrale */}
              <div className="block lg:hidden">
                {/* “Capogruppo” */}
                <div className="flex flex-col items-center gap-5 mb-0 md:mb-2">
                  <div className="flex flex-col justify-center items-center w-[200px] h-[200px] bg-[#D6D8E7] rounded-full">
                    <div className="relative flex flex-col justify-center items-center w-[150px] h-[150px] bg-[#0E3761] rounded-full">
                      <p className="text-[18px] text-white font-bold text-center leading-tight">
                        Società<br />Reale Mutua<br />di<br />Assicurazioni
                      </p>
                      <img src={ItaFlag} alt="Italia" className="absolute -bottom-2 w-[28px] h-auto" />
                    </div>
                  </div>
                </div>

                <div className="absolute top-[280px] right-[10px]">
                  <h3 className="text-[#002655] text-[10px] font-bold leading-[1.1em] mb-2 text-center">CAPOGRUPPO<br/>Società<br/>Benefit</h3>
                  <button
                    className="bt-secondary flex items-center gap-2"
                    style={{ fontSize: "10px", padding:"2px" }}
                    onClick={() => setIsReportOpen(true)} 
                  >
                  <img src={arrowIcon} alt="Arrow" className="w-[10px] h-[10px]" />
                    Approfondisci
                  </button>
                </div>


                {/* Timeline a due colonne */}
                <div className="relative px-2">
                  {/* Linea centrale */}
                  <div className="pointer-events-none absolute left-1/2 top-0 bottom-0 w-[2px] -translate-x-1/2 bg-[#0E3761]/30" />

                  {/* Griglia 2 colonne */}
                  <div className="grid grid-cols-2 gap-y-5">
                    <TimelineNode
                      id="ass"
                      title="Imprese Assicurative"
                      side="left"
                      openId={openId}
                      setOpenId={setOpenId}
                    />
                    <TimelineNode
                      id="srv"
                      title="Imprese di Servizi"
                      side="right"
                      openId={openId}
                      setOpenId={setOpenId}
                    />
                    <TimelineNode
                      id="imm"
                      title="Imprese Immobiliari"
                      side="left"
                      openId={openId}
                      setOpenId={setOpenId}
                    />
                    <TimelineNode
                      id="hold"
                      title="Holding Assicurative"
                      side="right"
                      openId={openId}
                      setOpenId={setOpenId}
                    />
                    <TimelineNode
                      id="hsrv"
                      title="Holding di Servizi"
                      side="left"
                      openId={openId}
                      setOpenId={setOpenId}
                    />
                  </div>

                  {/* Pannello centrale sotto i pallini */}
                  <MobileCenterPanel openId={openId}>
                    {/* ASSICURATIVE */}
                    {openId === "ass" && (
                      <div className="flex flex-row">
                        <ul className="w-1/2 p-1 text-[14px] text-[#0E3761] space-y-1">
                          <Flag code="IT" />
                          <li className="font-bold">Italiana Assicurazioni SpA<br/>99,94%</li>
                          <li className="font-bold text-[#2E6FB8]">◆ Credem Assicurazioni SpA<br/>50,00%</li>
                          <Flag code="ES" />
                          <li className="font-bold">Reale Seguros Generales SAU<br/>100,00%</li>
                          <li className="font-bold">Reale Vida y Pensiones SA<br/>100,00%</li>
                        </ul>
                        <ul className="w-1/2 p-1 text-[14px] text-[#0E3761] space-y-1">
                          <Flag code="CL" />
                          <li className="font-bold">Reale Chile Seguros SA<br/>100,00%</li>
                          <Flag code="GR" />
                          <li className="font-bold">Ydrogios Insurance and Reinsurance SA<br/>86,15%</li>
                        </ul>
                      </div>
                    )}

                    {/* SERVIZI */}
                    {openId === "srv" && (
                      <div className="flex flex-row">
                        <ul className="w-1/2 p-1 text-[14px] text-[#0E3761] space-y-1">
                          <Flag code="IT" />
                          <li className="font-bold">Banca Reale SpA<br/>100,00%</li>
                          <li className="font-bold">Blue Assistance SpA<br/>100,00%</li>
                          <li className="font-bold">Reale Ites Srl<br/>100,00%</li>
                          <li className="font-bold">Italnext Srl<br/>99,94%</li>
                          <li className="font-bold">Rem Intermediazioni Srl<br/>99,94%</li>
                          <li className="font-bold">Blue Health Center Srl<br/>100,00%</li>
                        </ul>
                        <ul className="w-1/2 p-1 text-[14px] text-[#0E3761] space-y-1">
                          <li className="font-bold text-[#2E6FB8]">◆ InSalute Servizi SpA<br/>35,00%</li>
                          <li className="font-bold text-[#2E6FB8]">◆ Pharmercure Srl in liquidazione<br/>46,40%</li>
                          <li className="font-bold">Circolo Sportivo Reale Group SSD a RL<br/>100,00%</li>
                          <Flag code="ES" />
                          <li className="font-bold">Reale Ites Esp SL<br/>100,00%</li>
                          <li className="font-bold">Reale Blue Service SLU<br/>100,00%</li>
                        </ul>
                      </div>
                    )}

                    {/* IMMOBILIARI */}
                    {openId === "imm" && (
                      <ul className="space-y-2 text-[14px] text-[#0E3761]">
                        <Flag code="IT" />
                        <li className="font-bold">Reale Immobili SpA<br/>99,99%</li>
                        <Flag code="ES" />
                        <li className="font-bold">Reale Immobili España SA<br/>100,00%</li>
                      </ul>
                    )}

                    {/* HOLDING ASSICURATIVE */}
                    {openId === "hold" && (
                      <ul className="space-y-2 text-[14px] text-[#0E3761]">
                        <Flag code="IT" />
                        <li className="font-bold">Reale International Srl<br/>100,00%</li>
                        <Flag code="CL" />
                        <li className="font-bold">Reale Group Latam SpA<br/>100,00%</li>
                        <li className="font-bold">Reale Group Chile SpA<br/>100,00%</li>
                      </ul>
                    )}

                    {/* HOLDING DI SERVIZI */}
                    {openId === "hsrv" && (
                      <ul className="space-y-2 text-[14px] text-[#0E3761]">
                        <Flag code="IT" />
                        <li className="font-bold">Reale Services Srl<br/>100,00%</li>
                        <button
                          className="bt-secondary flex items-center gap-2 mt-2"
                          style={{ fontSize: "12px", padding: "5px 12px" }}
                          onClick={() => setIsGreciaOpen(true)}   // ⬅️ apre popup Grecia
                        >
                          Approfondisci
                        </button>
                      </ul>
                    )}
                  </MobileCenterPanel>

                  {/* Legenda */}
                  <div className="mt-8 flex flex-col gap-1 text-[13px] font-bold leading-tight">
                    <span className="text-[#0E3761]">Imprese consolidate integralmente</span>
                    <span className="text-[#2E6FB8]">◆ Imprese consolidate a Patrimonio Netto</span>
                  </div>

                  {/* CTA finale mobile */}
                  <div className="mt-6 flex justify-center">
                    <a href="https://www.realegroup.eu/groupshare/0/IT/ListaReportsAndAccounts/87/BILANCIO%20CONSOLIDATO%20RG%202025.pdf#page=18" target="_blank">
                      <button
                        className="bt-secondary2 text-sm px-4 py-2"
                        onClick={() => setIsReportOpen(true)}   // ⬅️ apre popup Report
                      >
                        <img src={arrowIconWhite} alt="Arrow" className="inline-block mr-2 w-[20px] h-[20px]" />
                        Consulta il Report - cap. 1 par. 1.1.3.1
                      </button>
                    </a>
                  </div>
                </div>
              </div>
              {/* /MOBILE */}
            </div>
          </div>
        </div>
      </div>

      {/* ⬇️ Render dei popup figli (fuori dal TimelineNode) */}
      <Sezione3popup2Grecia
        isOpen={isGreciaOpen}
        onClose={() => setIsGreciaOpen(false)}
      />
      <Sezione3popup3
        isOpen={isReportOpen}
        onClose={() => setIsReportOpen(false)}
      />
    </>,
    document.body
  );
}

/* ——— Sub-components ——— */

/** Nodo timeline: pallino vicino alla linea centrale, con il NOME dentro al cerchio. */
function TimelineNode({ id, title, side = "right", openId, setOpenId }) {
  const isOpen = openId === id;
  const containerAlign = "justify-center";

  return (
    <div className={`relative flex ${containerAlign}`}>
      <button
        type="button"
        aria-expanded={isOpen}
        onClick={() => setOpenId(isOpen ? null : id)}
        className="group select-none"
      >
        {/* Pallino doppio con titolo al centro */}
        <div className="relative grid place-items-center w-28 h-28 rounded-full bg-[#B3B8D0] shadow">
          <div className="relative grid place-items-center w-24 h-24 rounded-full bg-[#D6D8E7] text-center">
            <span className="text-[#002655] text-[16px] font-semibold leading-tight">
              {title}
            </span>
            {/* + / – in basso nel cerchio interno */}
            <span className="absolute bottom-1 text-[#002655] text-[16px] font-bold">
              {isOpen ? "–" : "+"}
            </span>
          </div>
        </div>
      </button>
    </div>
  );
}

/** Pannello centrale che si apre sotto i pallini (slide-down) */
function MobileCenterPanel({ openId, children }) {
  const isOpen = Boolean(openId);
  return (
    <div
      className={`
        mt-4 mx-auto w-full sm:w-[90%] md:w-[80%]
        bg-[#E7E3DF] shadow-2xl
        transition-all duration-300 ease-out overflow-hidden
        ${isOpen ? "max-h-[1200px] opacity-100 translate-y-0" : "max-h-0 opacity-0 -translate-y-2"}
      `}
      aria-hidden={!isOpen}
    >
      <div className="p-4">{children}</div>
    </div>
  );
}
